import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';
import R from 'ramda';
import LockIcon from 'material-ui/svg-icons/action/lock';
import { updateCReportProps } from '../../stores/contracting-reports/actions';
import SampleProgressReport from './sampleTables/progressReport';
import { openUpgradeFrom as openUpgradeFromAction } from '../../stores/ui/components/upgrade/upgrade-actions';
import Allotments from './allotment';
import Blackouts from './blackout';
import SuggestionAReport from './suggestion';
import WallWrapper from '../wall/wrapper';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);
const propTypes = {
  updateProps: PropTypes.func,
  contractingReports: PropTypes.object,
  plan: PropTypes.string,
  companyType: PropTypes.string,
  currentYear: PropTypes.object,
  openUpgradeFrom: PropTypes.func,
  userId: PropTypes.string,
};

class ReportList extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  render() {
    const {
      companyType,
      contractingReports,
      currentYear,
      openUpgradeFrom,
      plan,
      updateProps,
      userId,
    } = this.props;
    const downloadFile = (reportType, startDate, endDate) => {
      window.open(`${window.location.protocol}//${window.location.host}/proxy/contracting/${reportType}?startDate=${startDate}&endDate=${endDate}`);
      updateProps({ generatingReport: false });
    };

    const generateRightSide = label => (
      <div>
        <div style={{ clear: 'both', padding: '0 8px' }}>
          {
            R.call(R.cond([
              [R.equals('ALLOTMENT REPORT'), R.always(<Allotments />)],
              [R.equals('BLACKOUT DATES REPORT'), R.always(<Blackouts companyType={companyType} />)],
              [R.equals('PROGRESS REPORT'), R.always(<div><SampleProgressReport /></div>)],
            ]), label)
          }
          <WallWrapper blocker slug="upgrade-rates-reports" lockIcon amazonOrange>
            <RaisedButton
              label={contractingReports.generatingReport ? 'report is being generated.' : `download ${label}`}
              onTouchTap={() => {
                updateProps({ generatingReport: true });
                if (contractingReports.selectedReport === 'allotment' && contractingReports.alloReport === 'detailed') {
                  return downloadFile('detailedAllotmentReport', currentYear.startDate, currentYear.endDate);
                }
                if (contractingReports.selectedReport === 'allotment' && contractingReports.alloReport === 'summary') {
                  return downloadFile('summaryAllotmentReport', currentYear.startDate, currentYear.endDate);
                }
                if (contractingReports.selectedReport === 'blackout' && contractingReports.blackoutReport === 'newContracts') {
                  return downloadFile('blackoutNCReport', currentYear.startDate, currentYear.endDate);
                }
                if (contractingReports.selectedReport === 'blackout' && contractingReports.blackoutReport === 'templates') {
                  return downloadFile('blackoutTemplatesReport', currentYear.startDate, currentYear.endDate);
                }
                return downloadFile('progressReport', currentYear.startDate, currentYear.endDate);
              }}
              secondary
              style={{ marginTop: '32px' }}
              disabled={isNilOrEmpty(contractingReports.startDate)
                || contractingReports.generatingReport}
            />
          </WallWrapper>
        </div>
      </div>
    );

    return R.call(R.cond([
      [R.equals('progress'), R.always(generateRightSide('PROGRESS REPORT'))],
      [R.equals('allotment'), R.always(generateRightSide('ALLOTMENT REPORT'))],
      [R.equals('blackout'), R.always(generateRightSide('BLACKOUT DATES REPORT'))],
      [R.equals('suggestion'), R.always(<SuggestionAReport />)],
      [R.T, R.always(<span />)],
    ]), contractingReports.selectedReport);
  }
}

ReportList.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  updateProps: (...args) => dispatch(updateCReportProps(...args)),
  openUpgradeFrom: () => dispatch(openUpgradeFromAction('downloadContractingReportBtn')),
});

const mapStateToProps = ({ contractingReports, user, contracting }) => ({
  contractingReports: contractingReports.toJS(),
  currentYear: contracting.currentYear,
  plan: user.get('billingPlan'),
  companyType: user.getIn(['user', 'type']),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportList);



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/rightSide.jsx